import React from "react";

const DealInputs = ({ dealType, state, update }) => {
  return (
    <div className="row">
      {dealType.fields.includes("guarantee") && (
        <div className={dealType.fields.length > 2 ? "col-4" : "col-6"}>
          <div className="form-group">
            <label className="small text-muted mb-1">Guarantee</label>
            <div className="input-group">
              <div className="input-group-prepend">
                <span className="input-group-text" style={{ border: "1px solid var(--od-c-d5d7da, #d5d7da)" }}>$</span>
              </div>
              <input
                type="number"
                className="form-control"
                placeholder="e.g. 2500"
                value={state.guarantee}
                onChange={(e) => update({ guarantee: e.target.value })}
                style={{
                  backgroundColor: "var(--sl-bg-warning-primary)",
                  fontWeight: 400,
                  border: "1px solid var(--od-c-d5d7da, #d5d7da)",
                }}
              />
            </div>
          </div>
        </div>
      )}

      {dealType.fields.includes("doorPercentage") && (
        <div className={dealType.fields.length > 2 ? "col-4" : "col-6"}>
          <div className="form-group">
            <label className="small text-muted mb-1">Door %</label>
            <div className="input-group">
              <input
                type="number"
                className="form-control"
                value={state.doorPercentage}
                onChange={(e) =>
                  update({ doorPercentage: e.target.value })
                }
                min={0}
                max={100}
                style={{
                  backgroundColor: "var(--sl-bg-warning-primary)",
                  fontWeight: 400,
                  border: "1px solid var(--od-c-d5d7da, #d5d7da)",
                }}
              />
              <div className="input-group-append">
                <span className="input-group-text" style={{ border: "1px solid var(--od-c-d5d7da, #d5d7da)" }}>%</span>
              </div>
            </div>
          </div>
        </div>
      )}

      {dealType.fields.includes("breakpoint") && (
        <div className="col-4">
          <div className="form-group">
            <label className="small text-muted mb-1">Breakpoint</label>
            <div className="input-group">
              <div className="input-group-prepend">
                <span className="input-group-text" style={{ border: "1px solid var(--od-c-d5d7da, #d5d7da)" }}>$</span>
              </div>
              <input
                type="number"
                className="form-control"
                placeholder="e.g. 5000"
                value={state.breakpoint}
                onChange={(e) => update({ breakpoint: e.target.value })}
                style={{
                  backgroundColor: "var(--sl-bg-warning-primary)",
                  fontWeight: 400,
                  border: "1px solid var(--od-c-d5d7da, #d5d7da)",
                }}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DealInputs;
